module.exports = __webpack_public_path__ + "img/logo.e2cb65a9.svg";